import { type BudgetFormatOptions } from './types'

export const DEFAULT_FORMAT_OPTIONS: BudgetFormatOptions = {
  currency: true,
  defaultValue: '—',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  useSystemLocale: false,
}
